<template>
  <highcharts class="chart" :options="getChartOptions(chartOptions)" :updateArgs="updateArgs"></highcharts>
</template>

<script>
  export default {
    name: 'DynamicChart',
    data () {
      return {
        updateArgs: [true, true, {duration: 1000}]
      }
    },
    props: {
      chartOptions: {
        type: Object,
        required: false
      },
      needTitle: {
        type: Boolean,
        required: false
      }
    },
    methods: {
      getChartOptions (chart) {
        var chatNewOptions = {
          chart: {
            type: '',
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true
              },
            }
          },
          title: {
            text: ''
          },
          subtitle: {
            text: ''
          },
          xAxis: {
            categories: []
          },
          yAxis: {
            title: {
              text: ''
            }
          },
          series: [{
            showInLegend: false,
            name: '',
            data: [],
            color: ''
          }
          ]
        }
        if (chart.type) {
          chatNewOptions.chart.type = chart.type.toLowerCase()
        }
        if (this.needTitle && chart.title) {
          chatNewOptions.title.text = chart.title
        }
        if (chart.subtitle) {
          chatNewOptions.subtitle.text = chart.subtitle
        }
        if (chart.groupByColumn) {
          chatNewOptions.yAxis.title.text = 'Result by ' + chart.groupByColumn.columnTitle
        }
        let showInLegend = chart.showLegend && chart.showLegend === true
        if (chart.categories) {
          chatNewOptions.xAxis.categories = chart.categories
        }

        const seriesList = []
        chart.series.forEach(function(serie) {
          const seriesDatalist = [];
          let seriesDataLoop = 0;
          serie.data.forEach(function(item) {
            if (serie.seriesTotalValue) {
              seriesDatalist.push([ Math.round(item * 100 / serie.seriesTotalValue * 100) / 100 + '% <br>(' + chart.categories[seriesDataLoop] + ')', item]);
            } else {
              seriesDatalist.push([item]);
            }
            seriesDataLoop++;
          });
          seriesList.push({
            name: serie.columnTitle,
            color: serie.columnColor,
            showLegend: showInLegend,
            data: seriesDatalist
          })
        })
        chatNewOptions.series = seriesList
        return chatNewOptions
      }
    }
  };
</script>

<style scoped>

</style>